import { IconProps } from './types';

export const DocumentIcon = ({ title = 'Document Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...props}>
        <title>{title}</title>
        <path fill="#D9DBDD" d="m45 8 11 11v35a2 2 0 0 1-2 2H24v-3a2 2 0 0 0-2-2h-6V10a2 2 0 0 1 2-2z"></path>
        <path fill="#C2C4C8" d="M56 19 45 8v11z"></path>
        <path fill="#A8AAB1" d="M22 29h28v2H22zM22 34h28v2H22zM22 39h28v2H22zM22 19h10v2H22zM22 24h28v2H22z"></path>
        <circle cx="24" cy="40" r="16" fill="#00C5B4"></circle>
        <path
            fill="#fff"
            d="M20 36a5 5 0 0 1 10 0v1a1 1 0 1 1-2 0v-1a3 3 0 1 0-6 0v4h4a1 1 0 1 1 0 2h-4v5h6v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2h-9a1 1 0 1 1 0-2h1v-5h-1a1 1 0 1 1 0-2h1z"
        ></path>
    </svg>
);
